module.exports = window.GrtSubjectMaterialLowcode;